import { SubscriptionTier } from '@wwe-portal/entities/subscription.type';

import type { ExclusiveItemProps } from './exclusive-item';
import {
  ExclusiveItemDesktop,
  ExclusiveItemMobile,
  ExclusiveItemDesktopSkeleton,
  ExclusiveItemMobileSkeleton,
} from './exclusive-item';
import { subscriptionMap } from './tier-badge';
import React from 'react';
import { Each } from '../../../components/utils';

interface BodyProps {
  exclusiveItemList: Record<SubscriptionTier, ExclusiveItemProps[]>;
  onClick: (offer: ExclusiveItemProps) => void;
  onShowOfferCard: (offer: ExclusiveItemProps) => void;
  processingOfferId: string | undefined;
}

export function BodyList({
  exclusiveItemList,
  onClick,
  onShowOfferCard,
  processingOfferId,
}: Readonly<BodyProps>) {
  return (
    <>
      {!Object.keys(exclusiveItemList).length && (
        <div className="flex flex-col flex-wrap justify-start gap-y-[10px]">
          <Each
            data={new Array(12).fill(0)}
            render={(_, index) => <ExclusiveItemMobileSkeleton key={index} />}
          />
        </div>
      )}
      {Object.values(SubscriptionTier).map((tier) =>
        exclusiveItemList[tier].length > 0 ? (
          <React.Fragment key={tier}>
            <div className="text-text300 font-poppins py-3 text-base font-[600]">
              {subscriptionMap[tier].name}
            </div>
            <div className="flex flex-col flex-wrap justify-start gap-y-[10px]">
              <Each
                data={exclusiveItemList[tier]}
                render={(item: ExclusiveItemProps) => (
                  <div className="w-full" key={item.id}>
                    <ExclusiveItemMobile
                      exclusiveItem={item}
                      isLoading={processingOfferId === item.offerData.id}
                      onClick={onClick}
                      onShowOfferCard={onShowOfferCard}
                    />
                  </div>
                )}
              />
            </div>
          </React.Fragment>
        ) : null
      )}
    </>
  );
}

export function BodyGrid({
  exclusiveItemList,
  onClick,
  processingOfferId,
}: Readonly<BodyProps>) {
  return (
    <>
      {!Object.keys(exclusiveItemList).length && (
        <div className="3xl:grid-cols-5 grid grid-cols-2 gap-[30px] xl:grid-cols-3 2xl:grid-cols-3">
          <Each
            data={new Array(12).fill(0)}
            render={(_, index) => <ExclusiveItemDesktopSkeleton key={index} />}
          />
        </div>
      )}
      {Object.values(SubscriptionTier).map((tier) =>
        exclusiveItemList[tier].length > 0 ? (
          <React.Fragment key={tier}>
            <div className="text-text300 font-poppins py-3 text-base font-[600] md:text-xl">
              {subscriptionMap[tier].name}
            </div>
            <div
              className="3xl:grid-cols-5 grid grid-cols-2 2xl:grid-cols-3"
              style={{ gap: '1.875rem' }}
            >
              <Each
                data={exclusiveItemList[tier]}
                render={(item: ExclusiveItemProps) => (
                  <div key={item.id}>
                    <ExclusiveItemDesktop
                      exclusiveItem={item}
                      isLoading={processingOfferId === item.offerData.id}
                      onClick={onClick}
                    />
                  </div>
                )}
              />
            </div>
          </React.Fragment>
        ) : null
      )}
    </>
  );
}
